export enum UIViewEnum
{
    None = -1,

    //////////////////////////////////////////////////////////////////////
    //#region Group Views
    Group_SummaryListing = 0,
    Group_SummaryListing_Devices = 1,
    Group_SummaryListing_Wells = 2,
    Group_SummaryListing_TankBatteries = 3,
    Group_SummaryListing_AlarmLynx = 4,
    Group_SummaryListing_CompressorLynx = 5,

    Group_ProductionDashboard = 6,
    Group_MapView = 7,
    Group_HMIView = 8,
    Group_MarketingReport = 9,
    Group_ManualEntry = 10,
    Group_GraphReport = 11,
    Group_Graph = 12,
    Group_Reporting = 13,
    Group_TankRelationshipReport = 14,
    Group_GaugeSheetExport = 15,
    Group_SendReport = 16, //This is disabled in the current WebAPI, yet it's somehow still appearing in SCADALynx.
    Group_CustomForm = 17,
    Group_AlarmDashboard = 18,
    Group_Dashboard = 19,
    //#endregion

    MyScheduledReports = 30,

    //////////////////////////////////////////////////////////////////////
    //#region Device Views
    Device_Details = 100,
    Device_Details_Values = 101,
    Device_Details_Properties = 102,
    Device_Details_Defaults = 103,
    Device_Details_AlarmSetpoints = 104,
    Device_Details_Attachments = 105,
    Device_Details_History = 106,
    Device_Details_Membership = 107,
    Device_Details_Relationships = 108,
    Device_Details_RunTickets = 109,

    Device_Graph = 110,
    Device_ProductionForecasting = 111,
    Device_MarketingReport = 112,
    Device_HistoricalData = 113,
    Device_GasChart = 114,
    Device_ManualEntry = 115,
    Device_GaugeSheet = 116,
    Device_HMIView = 117,
    Device_Dynacard = 118,
    Device_PlungerAnalysis = 119,

    Device_CustomForm = 120,
    Device_ExternalContent = 121,

    Device_Dashboard = 122,



    //Device_DynacardDashboard = 122,
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Well Views
    Well_Details = 200,
    Well_Details_Values = 201,
    Well_Details_Properties = 202,
    //Well_Details_Defaults = 203,
    Well_Details_AlarmSetpoints = 204,
    Well_Details_Attachments = 205,
    Well_Details_History = 206,
    //Well_Details_Membership = 207,
    Well_Details_Relationships = 208,
    //Well_Details_RunTickets = 209,

    Well_Graph = 210,
    Well_CustomForm = 211,
    Well_ExternalContent = 212,
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Tank Battery Views
    TankBattery_Details = 300,
    TankBattery_Details_Values = 301,
    TankBattery_Details_Properties = 302,
    TankBattery_Details_Defaults = 303,
    TankBattery_Details_AlarmSetpoints = 304,
    TankBattery_Details_Attachments = 305,
    TankBattery_Details_History = 306,
    TankBattery_Details_Membership = 307,
    TankBattery_Details_Relationships = 308,
    TankBattery_Details_RunTickets = 309,

    TankBattery_CustomForm = 310,
    TankBattery_ExternalContent = 311,
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Tank Views
    Tank_Details = 400,
    Tank_Details_Values = 401,
    Tank_Details_Properties = 402,
    Tank_Details_Defaults = 403,
    Tank_Details_AlarmSetpoints = 404,
    Tank_Details_Attachments = 405,
    Tank_Details_History = 406,
    Tank_Details_Membership = 407,
    Tank_Details_Relationships = 408,
    Tank_Details_RunTickets = 409,

    Tank_CustomForm = 410,
    Tank_ExternalContent = 411,
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Tag Views
    Tag_Details = 500,
    Tag_Details_Values = 501,
    Tag_Details_Properties = 502,
    Tag_Details_AlarmSetpoints = 503,
    Tag_Details_Attachments = 504,
    Tag_Details_History = 505,
    Tag_Details_RuntimeStatistics = 506,
    Tag_ManualEntry = 507,
    //#endregion

    //////////////////////////////////////////////////////////////////////
    //#region Misc Views
    Login = 9000,
    ChangePassword = 9001,
    SearchResults = 9002,
    Playground = 9003, // FOR DEVELOPER USE ONLY!
    //#endregion

    ////
    //// Admin Tools
    ////
    Administration = 899,
    //FacilitiesAdmin = 901,
    ////AnalyticsAdmin = 902,
    //SetPointAdmin = 903,
    AlarmSchemeAdmin = 904,
    ScheduleAdmin = 905,
    //AdvancedSecurity = 908,
    UsersAndSecurity = 909,
    //UserMobileConfig = 910,
    GroupAdmin = 911,
    //UserDetails = 912,
    LookupListAdmin = 913,
    NotificationListAdmin = 914,
    //UnitSetAdmin = 915,
    AccountingAdmin = 916,
    //UserListAdmin = 917,
    //IssueEventCategoryAdmin = 918,
    TankPadAdmin = 919,
    //ManualEntryAdmin = 920,
    AlarmSetPointReport = 921,
    AlarmNotificationReport = 922,
    RolePermissionReport = 923,
    UserPermissionReport = 924,
    UserListReport = 925,
    //InvoiceDetails = 926,
    //InvoiceHistory = 927,
    //AttributeValueOptionsAdmin = 928,
    MemoAutoTextAdmin = 929,
    //WellManagement = 930,
    //AnalyticsModelsManagement = 931,
    ////AnalyticsTagManagement = 932,
    //DeviceConfiguration = 933,
    BadCommsReport = 934,
    //ApplicationAdmin = 935,
    ReportScheduleAdmin = 936,
    RulesEngineAdmin = 937,
    PollingFrequencyAdmin = 938,
    DataFileImport = 939,
    ObjectAdmin = 940,
    CommManagement = 941,
    //AlarmNotificationDashboard = 942,
    //AlarmNotificationDetailDashboard = 943,
    DisabledRecipientsReport = 944,
    TemplateAdmin = 945,
    AttributeManagement = 946,
    SetPointAdmin_v2 = 947,
    AuditReporting = 948,
    TankStyleAdmin = 949,
    ConfigurationCleanup = 950,

    // Administration child view enums.  Currently these are only in
    // the front end code, availability/access to these features is based
    // soley on the admin UI View ID
    ObjectAdmin_Manage_Objects = 2000,
    AuditReporting_Report = 2001,
    UserPermissions_Report = 2002,
    RolePermissions_Report = 2003,
    UserList_Report = 2004,
    Setpoint_Report = 2005,
    Disabled_Recipients_Report = 2006,
    ObjectAdmin_TankStyleAdmin = 2007,
    ObjectAdmin_TankPadAdmin = 2008,
    AccountingAdmin_InvoiceDetails = 2009,

    Group_Properties = 2100,
    Group_Contents = 2101,
    Group_ManualEntry_Configuration = 2102,
    Group_System_Balance_Configuration = 2103,
    Group_Clone_Membership = 2104,
    Group_Dynamic_Group_Configuration = 2105,

    UsersAndSecurity_UserRoleAdmin = 2200,
    UsersAndSecurity_SecurityPermissions = 2201,
    UsersAndSecurity_PageVisibilityAdmin = 2202,

    AlarmsAndNotification_SetPointAdmin = 2300,
    AlarmsAndNotification_NotificationListAdmin = 2301,
    AlarmsAndNotification_AlarmSchemeAdmin = 2302,
    AlarmsAndNotification_AlarmDashboard = 2303,
    AlarmsAndNotification_AlarmNotificationReport = 2304,
    AlarmsAndNotification_BadCommsReport = 2305,


    AdminMiscellaneous = 2305,
    AttributeManagement_Admin = 2306,
    LookupList_Admin = 2307,
    AlarmsAndNotification_AlarmScheduleAdmin = 2308,
    ReportScheduled_Admin = 2309,
    AdminMiscellaneous_DataFileImport = 2310,
    AlarmsAndNotification_RulesEngineAdmin = 2311,
    AdminMiscellaneous_MemoAutoTextAdmin = 2312,
    AdminMiscellaneous_ConfigurationCleanup = 2313,


    AdminAccounting = 2400,
    AdminAccounting_InvoiceDetails = 2401,
}


